import { render, staticRenderFns } from "./allocated-require.vue?vue&type=template&id=9672fdb4&scoped=true&"
import script from "./allocated-require.vue?vue&type=script&lang=js&"
export * from "./allocated-require.vue?vue&type=script&lang=js&"
import style0 from "./allocated-require.vue?vue&type=style&index=0&id=9672fdb4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9672fdb4",
  null
  
)

export default component.exports